var exports = {
  "w": "Section__T7PKB0",
  "y": "divider__QFCgLB",
};

module.exports = exports;
